module.exports = __webpack_public_path__ + "img/excel_1.57520776.png";